import Marquee from "../../lib/marquee";

export default function MarqueeComponent() {
  return (
    <Marquee
      pauseOnClick={false}
      gradient={false}
      autoFill={true}
      speed={30}
      style={{
        color: "#E8450E",
        fontSize: "1rem",
        textTransform: "uppercase",
        fontFamily: "'Space Grotesk', sans-serif",
        letterSpacing: "0.15rem",
        fontWeight: "700",
        padding: "12px 0",
        borderTop: "1px solid rgba(232, 69, 14, 0.12)",
        borderBottom: "1px solid rgba(232, 69, 14, 0.12)",
      }}
    >
      &nbsp; DTC &nbsp;&mdash;&nbsp; Digital Marketing &nbsp;&mdash;&nbsp; Brand Design &nbsp;&mdash;&nbsp; Ecommerce
      &nbsp;&mdash;&nbsp; Shopify Plus &nbsp;&mdash;&nbsp; Email Marketing &nbsp;&mdash;&nbsp; SEO &nbsp;&mdash;
    </Marquee>
  );
}
